import { Layout } from 'antd';
import { useGetMenuMaster, handlerDrawerOpen } from 'api/menu';
import DrawerHeader from './DrawerHeader';
import DrawerContent from './DrawerContent';
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';

const { Sider } = Layout;

export default function MainDrawer() {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;

  return (
    <Sider
      theme="dark"
      collapsible
      collapsed={!drawerOpen}
      onCollapse={(collapsed) => handlerDrawerOpen(!collapsed)}
      width={DRAWER_WIDTH}
      collapsedWidth={MINI_DRAWER_WIDTH}
      trigger={null}
      style={{
        background: 'linear-gradient(180deg, #12122a 0%, #1a1a2e 100%)',
        borderRight: '1px solid rgba(255,255,255,0.06)',
        boxShadow: '4px 0 24px rgba(0,0,0,0.18)',
        display: 'flex',
        flexDirection: 'column',
      }}
      className="sticky top-0 left-0 h-screen"
    >
      <DrawerHeader open={drawerOpen} />
      <DrawerContent />

      {/* Collapse toggle at bottom */}
      <div
        onClick={() => handlerDrawerOpen(!drawerOpen)}
        style={{
          borderTop: '1px solid rgba(255,255,255,0.06)',
          padding: '14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: drawerOpen ? 'flex-end' : 'center',
          cursor: 'pointer',
          color: 'rgba(255,255,255,0.35)',
          transition: 'color 0.2s',
        }}
        className="hover:!text-white"
      >
        {/* {drawerOpen ? <MenuFoldOutlined style={{ fontSize: 16 }} /> : <MenuUnfoldOutlined style={{ fontSize: 16 }} />} */}
      </div>
    </Sider>
  );
}
